<template>
    <div class="job-container">
      <h1 class="title">
        <span class="title-text">
          {{ job.title }}
        </span>
      </h1>
      <article class="container col-lg-6">
        <div class="description">
          {{{job.description}}}
        </div>
        <application-form keep-alive></application-form>
      </article>
    </div>
</template>

<style lang="sass">
  @import "../assets/scss/colors"
  @import "../assets/scss/variables"

  .job-container
    display: flex
    flex-direction: row
    justify-content: space-between
    width: 100%

    article
      flex: 1
      display: flex
      flex-direction: column

    .interested
      margin-top: 1.5em

    b
      color: $grey-507

    .title
      width: 10em
      height: 10em
      position: relative
      display: flex
      font-size: 1em
      margin-left: 3vw

      &:before
        content: ""
        display: block
        width: 100%
        height: 0
        padding-bottom: 100%
        border-radius: 50%
        transition: background 0.5s ease
        position: absolute
        z-index: -1
        background: $grey-507

      &:hover
        &:before
          //background: darken($grey-507, 15)

      .title-text
        color: $text-light-primary
        text-transform: uppercase
        align-self: center
        margin: 0 0.5em !important
        width: 100%
        text-align: center

  @media screen and (max-width: map_get($grid-breakpoints, "md"))
    .job-container
      flex-direction: column
      flex-wrap: wrap
      justify-content: center

      .title
        align-self: center
        margin-left: 0
        margin-bottom: 2em
</style>

<script>
    import ApplicationForm from './layout/applicationForm.vue';

    export default{
      data() {
        return {
          job: {}
        }
      },
      props: {
        alerts: {
          default: [],
          type: Array
        }
      },
      components: {
        ApplicationForm
      },
      ready() {
        this.$http.get('jobs/'+ this.$route.params.jobId).then((response) => {
          this.$set('job', response.data.data[0]);
        }, (response) => {
          console.log("API ERROR", response);
        });
      }
    }
</script>



// WEBPACK FOOTER //
// viewJob.vue?03f6f542